import { jsx as c } from "react/jsx-runtime";
import l from "../components/snackbar/SnackBar.js";
import m from "../components/loading.diagnosis/LoadingDiagnosis.js";
import f from "../components/reset.alert/ResetAlert.js";
import { SNACKBAR_ROOT as w, DIAGNOSIS_LOADER_ROOT as i, RESET_ALERT_ROOT as A } from "./popups.js";
const t = 4e3, n = (s, e, r, o = t, a = !1) => {
  w.render(
    /* @__PURE__ */ c(
      l,
      {
        messageType: r,
        timer: o,
        title: s,
        message: e,
        ignoreMouse: a
      }
    )
  );
}, g = (s, e, r, o = t, a = !1, R = !1) => {
  A.render(
    /* @__PURE__ */ c(
      f,
      {
        messageType: r,
        timer: o,
        title: s,
        message: e,
        ignoreMouse: R,
        ignoreCloseButton: a
      }
    )
  );
}, p = () => {
  i.render(
    /* @__PURE__ */ c(m, { timer: 15e4 })
  );
}, u = (s) => {
  i.unmount();
}, E = (s, e = "") => {
  n(e, s, "error");
}, T = (s, e = "", r) => {
  n(e, s, "info", r);
}, _ = (s, e = "") => {
  n(e, s, "warning");
}, L = (s, e = "", r = t, o = !0) => {
  n(e, s, "success", r, o);
}, M = () => {
  p();
}, I = () => {
  u();
}, k = (s, e = "Password Reset") => {
  g(e, s, "reset-alert-success");
}, x = (s, e = "Password Reset", r = t, o = !1) => {
  g(e, s, "reset-alert-error", r, o);
};
export {
  I as closeDiagnosis,
  M as showDiagnosing,
  E as showErrorMessage,
  x as showFailureResetAlert,
  T as showInfoMessage,
  L as showSuccessMessage,
  k as showSuccessResetAlert,
  _ as showWarningMessage
};
